<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <topPiece></topPiece>
      <div class="container">
        <titleConfig
            :title="langSet == 'cn' ? '我的商机' : 'My Business Opportunity'"
            :type="2"
        ></titleConfig>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="langSet == 'cn' ? '我的发布' : 'My Posts'" name="publish">
            <businessList :businessList="publishListData" :external="'business'" @item_click="item_click"></businessList>
            <nodata v-if="publishListData.length == 0"></nodata>
          </el-tab-pane>
          <el-tab-pane :label="langSet == 'cn' ? '我的应答' : 'My Responses'" name="reply">
            <list :list="replyListData"></list>
            <nodata v-if="replyListData.length == 0"></nodata>
          </el-tab-pane>
          <el-tab-pane :label="langSet == 'cn' ? '我的索样' : 'Request Sample'" name="mineProduct">
            <productList :productLists="listData" :external="'product'" @item_click="item_click" ></productList>
            <nodata v-if="listData.length == 0"></nodata>
          </el-tab-pane>
          <el-tab-pane :label="langSet == 'cn' ? '我的留言' : 'Message'" name="mineExhibitor">
            <companyList :companyLists="listData" :external="'company'" @item_click="item_click" ></companyList>
            <nodata v-if="listData.length == 0"></nodata>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>


<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import topPiece from "@/components/topPiece.vue";
import nodata from "@/components/nodata.vue";
import businessList from "../business/component/business_list.vue";
import productList from "../product/component/product_list.vue";
import companyList from "../company/component/company_list.vue";
import list from "./components/list.vue";
import {publishList, replyList, consultationList} from "@/api/api";

export default {
  components: {
    top,
    bottom,
    topPiece,
    titleConfig,
    nodata,
    businessList,
    productList,
    companyList,
    list,
  },
  data() {
    return {
      langSet: "",
      activeName: "publish",
      publishListData: [], //发布列表
      replyListData: [], //应答列表
      listData: [], //索样列表 留言列表
    };
  },
  created() {
  },
  mounted() {
    this.langSet = this.$language;
    //25.6.18 获取我的发布列表 dxm
    this.getPublishList();
  },
  methods: {
    async getPublishList() {
      const res = await publishList();
      this.publishListData = res.data.lists;
      console.log(this.publishListData, "====res");
    },
    async getReplyList() {
      const res = await replyList();
      this.replyListData = res.data.lists;
      console.log(this.replyListData, "====res");
    },
    async getConsultationList() {
      let data = {
        condition: this.activeName,
        page_no: "1",
        page_size: "25",
      };
      const res = await consultationList(data);
      this.listData = res.data.lists;
      console.log(this.listData, "====res");
    },
    //跳转详情
    item_click(item,type){
      if(type=='product'){
        this.$router.push({
          path: "/product",
          query: {
            detail_show: true,
            product_long_id: item.product_long_id,
            // exhibitor_long_id: item.exhibitor_long_id,
          },
        });
      }else if(type=='company'){
        this.$router.push({
          path: "/company",
          query: {
            detail_show: true,
            exhibitor_long_id: item.exhibitor_long_id,
          },
        });

      }else if(type=='business'){
        this.$router.push({
          path: "/business",
          query: {
            detail_show: true,
            reply_list_show: true,
            id: item.id,
          },
        });

      }
    },
    handleClick(tab) {
      this.activeName = tab.name;
      console.log(tab.name, "===tab.name");
      switch (tab.name) {
        case "reply":
          this.getReplyList();
          break;
        case "mineProduct":
          this.getConsultationList();
          break;
        case "mineExhibitor":
          this.getConsultationList();
          break;
        default:
          this.getPublishList();
          break;
      }
    },
  },
};
</script>


<style scoped lang="scss">
.container {
  padding-bottom: 70px;
}

/deep/ .el-tabs__nav-wrap::after {
  display: none;
}

/deep/ .el-tabs__item {
  font-size: 30px;
  color: #888888;
  line-height: 61px;
  margin-top: 20px;
}

/deep/ .el-tabs__item {
  height: auto;
}

/deep/ .el-tabs__active-bar {
  height: 10px;
  width: 120px !important;
  bottom: 15px;
  background: rgba(230, 35, 68, 0.18);
}

/deep/ .el-tabs__item.is-active {
  color: #000;
}

@media only screen and (max-width: 767px) {
  /deep/ .el-tabs__item {
    font-size: 0.35rem;
    margin-top: 0.2rem;
    line-height: 0.69rem;
    padding: 0 10px;
  }
  /deep/ .el-tabs__active-bar {
    width: 1.38rem !important;
    height: 0.15rem;
    bottom: 9px;
  }
  /deep/ .el-tabs__nav-next,
  /deep/ .el-tabs__nav-prev {
    line-height: 57px;
  }
}
</style>